(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lord-bestsellers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lord-product-rail')) {
  customElements.define('lord-product-rail', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      this.track = this.querySelector('.ld-grid');
      if (!this.track || this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (target, name, handler, options = {}) => target.addEventListener(name, handler, { ...options, signal });
      this.rtl = getComputedStyle(this.track).direction === 'rtl';
      this.left = this.querySelector('[data-left]');
      this.right = this.querySelector('[data-right]');
      this.motion = this.querySelector('[data-motion]');
      this.controls = this.querySelector('.ld-slider-controls');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.hovered = false;
      this.focused = false;
      this.pointer = null;
      this.visible = false;
      this.autoDirection = 1;
      this.until = performance.now() + 1000;
      this.speed = Number(this.dataset.speed) || 25;
      this.lastTime = 0;
      this.max = 0;
      this.frame = 0;
      this.autoPosition = this.position();
      this.refresh = () => {
        this.max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.controls.hidden = this.max < 2;
        this.motion.hidden = this.dataset.autoplay !== 'true' || this.reduced.matches;
        this.autoPosition = this.position();
        this.updateButtons();
      };
      on(this.left, 'click', () => this.step(-1));
      on(this.right, 'click', () => this.step(1));
      on(this.motion, 'click', () => {
        this.userPaused = !this.userPaused;
        this.motion.setAttribute('aria-pressed', String(this.userPaused));
        this.motion.querySelector('[data-pause]').hidden = this.userPaused;
        this.motion.querySelector('[data-play]').hidden = !this.userPaused;
        this.motion.setAttribute('aria-label', this.rtl
          ? (this.userPaused ? 'تشغيل الحركة التلقائية' : 'إيقاف الحركة التلقائية')
          : (this.userPaused ? 'Play automatic scrolling' : 'Pause automatic scrolling'));
        this.autoPosition = this.position();
        this.until = performance.now() + 300;
      });
      on(this.track, 'pointerenter', e => { if (e.pointerType === 'mouse') this.hovered = true; });
      on(this.track, 'pointerleave', e => {
        if (e.pointerType === 'mouse') { this.hovered = false; this.rest(); }
      });
      on(this.track, 'focusin', () => { this.focused = true; });
      on(this.track, 'focusout', e => {
        this.focused = this.track.contains(e.relatedTarget);
        this.rest();
      });
      on(this.track, 'wheel', () => this.rest(), { passive: true });
      on(this.track, 'keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault(); this.step(e.key === 'ArrowLeft' ? -1 : 1);
        } else if (e.key === 'Home' || e.key === 'End') {
          e.preventDefault(); this.rest(); this.move(e.key === 'Home' ? 0 : this.max, true);
        }
      });
      on(this.track, 'scroll', () => this.updateButtons(), { passive: true });
      on(this.track, 'dragstart', e => e.preventDefault());
      on(this.track, 'pointerdown', e => {
        if (e.button !== 0 || this.pointer) return;
        this.pointer = { id: e.pointerId, x: e.clientX, position: this.position(), mouse: e.pointerType === 'mouse', dragged: false };
        this.rest();
      });
      on(window, 'pointermove', e => {
        const p = this.pointer;
        if (!p || p.id !== e.pointerId || !p.mouse) return;
        const delta = e.clientX - p.x;
        if (Math.abs(delta) > 6 && !p.dragged) {
          p.dragged = true;
          this.track.setPointerCapture(e.pointerId);
          this.track.classList.add('is-dragging');
        }
        if (p.dragged) {
          e.preventDefault();
          this.move(p.position + (this.rtl ? delta : -delta));
        }
      }, { passive: false });
      const endPointer = e => {
        const p = this.pointer;
        if (!p || p.id !== e.pointerId) return;
        this.suppressClickUntil = p.dragged ? performance.now() + 250 : 0;
        this.pointer = null;
        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(e.pointerId)) this.track.releasePointerCapture(e.pointerId);
        this.rest();
      };
      on(window, 'pointerup', endPointer);
      on(window, 'pointercancel', endPointer);
      on(this.track, 'lostpointercapture', endPointer);
      on(this.track, 'click', e => {
        if (performance.now() < (this.suppressClickUntil || 0)) { e.preventDefault(); e.stopPropagation(); }
      }, { capture: true });
      on(this, 'shopify:block:select', e => {
        this.editorSelected = true;
        e.target.closest('.ld-card')?.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
      });
      on(this, 'shopify:block:deselect', () => { this.editorSelected = false; this.rest(); });
      on(this.reduced, 'change', this.refresh);
      on(document, 'visibilitychange', () => { this.lastTime = 0; this.wake(); });
      this.resizeObserver = new ResizeObserver(this.refresh);
      this.resizeObserver.observe(this.track);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.lastTime = 0;
        this.wake();
      }, { threshold: 0.05 });
      this.observer.observe(this);
      this.refresh();
    }
    position() { return Math.max(0, this.rtl ? -this.track.scrollLeft : this.track.scrollLeft); }
    move(value, smooth = false) {
      const logical = Math.max(0, Math.min(this.max, value));
      this.track.scrollTo({ left: this.rtl ? -logical : logical, behavior: smooth && !this.reduced.matches ? 'smooth' : 'instant' });
    }
    rest() { this.until = performance.now() + 3000; this.autoPosition = this.position(); }
    step(physicalDirection) {
      this.rest();
      const card = this.track.querySelector('.ld-card');
      const distance = (card?.getBoundingClientRect().width || this.track.clientWidth) + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
      this.move(this.position() + physicalDirection * (this.rtl ? -1 : 1) * distance, true);
    }
    updateButtons() {
      const pos = this.position();
      this.left.disabled = this.rtl ? pos >= this.max - 1 : pos <= 1;
      this.right.disabled = this.rtl ? pos <= 1 : pos >= this.max - 1;
    }
    wake() {
      if (!this.frame && this.visible && !document.hidden) this.frame = requestAnimationFrame(t => this.tick(t));
    }
    tick(time) {
      this.frame = 0;
      if (!this.isConnected || !this.visible || document.hidden) { this.lastTime = 0; return; }
      const dt = this.lastTime ? Math.min((time - this.lastTime) / 1000, 0.05) : 0;
      this.lastTime = time;
      const active = this.dataset.autoplay === 'true' && !this.userPaused && !this.reduced.matches &&
        !this.hovered && !this.focused && !this.pointer && !this.editorSelected && this.max > 1 && time >= this.until;
      if (active) {
        this.autoPosition += this.autoDirection * this.speed * dt;
        if (this.autoPosition >= this.max || this.autoPosition <= 0) {
          this.autoPosition = Math.max(0, Math.min(this.max, this.autoPosition));
          this.autoDirection *= -1;
          this.until = time + 1100;
        }
        this.move(this.autoPosition);
      } else {
        this.autoPosition = this.position();
      }
      this.wake();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.controller = null;
      this.frame = 0;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lord-offers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lord-product-rail')) {
  customElements.define('lord-product-rail', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      this.track = this.querySelector('.ld-grid');
      if (!this.track || this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (target, name, handler, options = {}) => target.addEventListener(name, handler, { ...options, signal });
      this.rtl = getComputedStyle(this.track).direction === 'rtl';
      this.left = this.querySelector('[data-left]');
      this.right = this.querySelector('[data-right]');
      this.motion = this.querySelector('[data-motion]');
      this.controls = this.querySelector('.ld-slider-controls');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.hovered = false;
      this.focused = false;
      this.pointer = null;
      this.visible = false;
      this.autoDirection = 1;
      this.until = performance.now() + 1000;
      this.speed = Number(this.dataset.speed) || 25;
      this.lastTime = 0;
      this.max = 0;
      this.frame = 0;
      this.autoPosition = this.position();
      this.refresh = () => {
        this.max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.controls.hidden = this.max < 2;
        this.motion.hidden = this.dataset.autoplay !== 'true' || this.reduced.matches;
        this.autoPosition = this.position();
        this.updateButtons();
      };
      on(this.left, 'click', () => this.step(-1));
      on(this.right, 'click', () => this.step(1));
      on(this.motion, 'click', () => {
        this.userPaused = !this.userPaused;
        this.motion.setAttribute('aria-pressed', String(this.userPaused));
        this.motion.querySelector('[data-pause]').hidden = this.userPaused;
        this.motion.querySelector('[data-play]').hidden = !this.userPaused;
        this.motion.setAttribute('aria-label', this.rtl
          ? (this.userPaused ? 'تشغيل الحركة التلقائية' : 'إيقاف الحركة التلقائية')
          : (this.userPaused ? 'Play automatic scrolling' : 'Pause automatic scrolling'));
        this.autoPosition = this.position();
        this.until = performance.now() + 300;
      });
      on(this.track, 'pointerenter', e => { if (e.pointerType === 'mouse') this.hovered = true; });
      on(this.track, 'pointerleave', e => {
        if (e.pointerType === 'mouse') { this.hovered = false; this.rest(); }
      });
      on(this.track, 'focusin', () => { this.focused = true; });
      on(this.track, 'focusout', e => {
        this.focused = this.track.contains(e.relatedTarget);
        this.rest();
      });
      on(this.track, 'wheel', () => this.rest(), { passive: true });
      on(this.track, 'keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault(); this.step(e.key === 'ArrowLeft' ? -1 : 1);
        } else if (e.key === 'Home' || e.key === 'End') {
          e.preventDefault(); this.rest(); this.move(e.key === 'Home' ? 0 : this.max, true);
        }
      });
      on(this.track, 'scroll', () => this.updateButtons(), { passive: true });
      on(this.track, 'dragstart', e => e.preventDefault());
      on(this.track, 'pointerdown', e => {
        if (e.button !== 0 || this.pointer) return;
        this.pointer = { id: e.pointerId, x: e.clientX, position: this.position(), mouse: e.pointerType === 'mouse', dragged: false };
        this.rest();
      });
      on(window, 'pointermove', e => {
        const p = this.pointer;
        if (!p || p.id !== e.pointerId || !p.mouse) return;
        const delta = e.clientX - p.x;
        if (Math.abs(delta) > 6 && !p.dragged) {
          p.dragged = true;
          this.track.setPointerCapture(e.pointerId);
          this.track.classList.add('is-dragging');
        }
        if (p.dragged) {
          e.preventDefault();
          this.move(p.position + (this.rtl ? delta : -delta));
        }
      }, { passive: false });
      const endPointer = e => {
        const p = this.pointer;
        if (!p || p.id !== e.pointerId) return;
        this.suppressClickUntil = p.dragged ? performance.now() + 250 : 0;
        this.pointer = null;
        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(e.pointerId)) this.track.releasePointerCapture(e.pointerId);
        this.rest();
      };
      on(window, 'pointerup', endPointer);
      on(window, 'pointercancel', endPointer);
      on(this.track, 'lostpointercapture', endPointer);
      on(this.track, 'click', e => {
        if (performance.now() < (this.suppressClickUntil || 0)) { e.preventDefault(); e.stopPropagation(); }
      }, { capture: true });
      on(this, 'shopify:block:select', e => {
        this.editorSelected = true;
        e.target.closest('.ld-card')?.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
      });
      on(this, 'shopify:block:deselect', () => { this.editorSelected = false; this.rest(); });
      on(this.reduced, 'change', this.refresh);
      on(document, 'visibilitychange', () => { this.lastTime = 0; this.wake(); });
      this.resizeObserver = new ResizeObserver(this.refresh);
      this.resizeObserver.observe(this.track);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.lastTime = 0;
        this.wake();
      }, { threshold: 0.05 });
      this.observer.observe(this);
      this.refresh();
    }
    position() { return Math.max(0, this.rtl ? -this.track.scrollLeft : this.track.scrollLeft); }
    move(value, smooth = false) {
      const logical = Math.max(0, Math.min(this.max, value));
      this.track.scrollTo({ left: this.rtl ? -logical : logical, behavior: smooth && !this.reduced.matches ? 'smooth' : 'instant' });
    }
    rest() { this.until = performance.now() + 3000; this.autoPosition = this.position(); }
    step(physicalDirection) {
      this.rest();
      const card = this.track.querySelector('.ld-card');
      const distance = (card?.getBoundingClientRect().width || this.track.clientWidth) + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
      this.move(this.position() + physicalDirection * (this.rtl ? -1 : 1) * distance, true);
    }
    updateButtons() {
      const pos = this.position();
      this.left.disabled = this.rtl ? pos >= this.max - 1 : pos <= 1;
      this.right.disabled = this.rtl ? pos <= 1 : pos >= this.max - 1;
    }
    wake() {
      if (!this.frame && this.visible && !document.hidden) this.frame = requestAnimationFrame(t => this.tick(t));
    }
    tick(time) {
      this.frame = 0;
      if (!this.isConnected || !this.visible || document.hidden) { this.lastTime = 0; return; }
      const dt = this.lastTime ? Math.min((time - this.lastTime) / 1000, 0.05) : 0;
      this.lastTime = time;
      const active = this.dataset.autoplay === 'true' && !this.userPaused && !this.reduced.matches &&
        !this.hovered && !this.focused && !this.pointer && !this.editorSelected && this.max > 1 && time >= this.until;
      if (active) {
        this.autoPosition += this.autoDirection * this.speed * dt;
        if (this.autoPosition >= this.max || this.autoPosition <= 0) {
          this.autoPosition = Math.max(0, Math.min(this.max, this.autoPosition));
          this.autoDirection *= -1;
          this.until = time + 1100;
        }
        this.move(this.autoPosition);
      } else {
        this.autoPosition = this.position();
      }
      this.wake();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.controller = null;
      this.frame = 0;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
